<ion-segment
  color="secondary"
  class="segment-options"
  [value]="segmentSelected"
  (ionChange)="onSegmentChange($event)"
  [disabled]="disabled"
>
  <ion-segment-button value="none" *ngIf="!coverLaminated">
    <ion-label
      >Blanco <br />
      y Negro</ion-label
    >
  </ion-segment-button>
  <ion-segment-button value="coverColor" *ngIf="this.printingGroup.printSettings.finishing !== 'stapled'">
    <ion-label [innerHTML]="getCoverColorTitle()"></ion-label>
  </ion-segment-button>
  <ion-segment-button value="docColor">
    <ion-label
      >Documento <br />
      a Color</ion-label
    >
  </ion-segment-button>
</ion-segment>
